import EmptyState from './EmptyState.component';

export * from './EmptyState.styled';
export * from './interfaces';

export default EmptyState;
